var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { property, query } from "lit/decorators.js";
import { html, css } from "lit";
import { stringDecoder, booleanDecoder, Calendar, parseFormat, PICInput, Position, PICValidate, PICMinDate, PICMaxDate, PICDateEditing, customElement, arrayDecoder, numberDecoder, PIC } from '../Internals';
let PICDualDate = class PICDualDate extends PICInput {
    get submitValue() {
        if (this.fromDate_ || this.toDate_)
            return this.fromHelper.toReturnValue() + '^' + this.toHelper.toReturnValue();
        else
            return '';
    }
    constructor() {
        super();
        this.fromDate_ = undefined;
        this.toDate_ = undefined;
        this.format_ = '';
        this.info_ = '';
        this.hasWeekNo_ = false;
        this.autoclose_ = false;
        this.removeClearBtn_ = false;
        this.isSimple = false;
        this.initVal = '';
        this.pos = Position.Day;
        this.sep = '';
        this.editing = false;
        this.editVal = '';
        this.fullYear = false;
        this.hasInvalidDate = false;
        this.fromPos = Position.Day;
        this.toPos = Position.Day;
    }
    connectedCallback() {
        super.connectedCallback();
        this.eType == 'default' ? this.eType = 'dualdate' : this.eType = 'old';
        let today_ = new Date();
        if (!this.fromDate_)
            this.fromDate_ = (today_.getFullYear() + '').padStart(4, '0') + ((today_.getMonth() + 1) + '').padStart(2, '0') + (today_.getDate() + '').padStart(2, '0');
        if (!this.toDate_)
            this.toDate_ = (today_.getFullYear() + '').padStart(4, '0') + ((today_.getMonth() + 1) + '').padStart(2, '0') + (today_.getDate() + '').padStart(2, '0');
        if (this.format_ === '') {
            this.format_ = PIC.getInstance.userConfig.dateFormat;
        }
        // Set up validation rules
        if (!this.valid)
            this.valid = new PICValidate([], this);
        this.valid.add(new PICMinDate(this, { ruleType: 'mindate', value: '1970-01-01' }));
        this.valid.add(new PICMaxDate(this, { ruleType: 'maxdate', value: '2038-01-19' }));
        this.valid.add(new PICDateEditing(this, { ruleType: 'validatedate', value: 'true' }));
        let format = parseFormat(this.format_);
        this.fromHelper = new Calendar({ dateString: this.fromDate_, fullYear: format.fullYear, sep: format.sep, order: format.posArr });
        this.toHelper = new Calendar({ dateString: this.toDate_, fullYear: format.fullYear, sep: format.sep, order: format.posArr });
        if (!this.textObj) {
            this.textObj = {
                fromText: 'from',
                toText: 'to',
                helpText: 'Max %x% days range'
            };
        }
        this.fullYear = format.fullYear;
        this.sep = format.sep;
        this.isSimple = format.sep.length === 0;
        this.setDisplayformat(format.posArr, format.fullYear);
    }
    static get styles() {
        const defaultStyle = css `
            .inner-input-old {
                width: 100%;
                font-family: monospace;
            }
            .picker {
                z-index: 500;
            }
            .picker.new{
                position: absolute;
                top: 40px;
            }
            .mockinputfld{
                background-color: #FFFFFF;
                box-sizing: border-box;
                font-family: monospace;
                border-color: rgb(118, 118, 118), rgb(133, 133, 133);
                border-style: solid;
                border-width: 1px;
                height: 1.35rem;
            }
            .mockinputfld.old{
                font-size: 16px;
            }
            .icon.inline {
                right: 9px;
                top: 4px;
            }
            .inner-input-default.high {
                font-size: 13px;
            }
            .inner-input-default.inline {
                width: 190px;
            }
            /* .inner-input-default.low{
                height: calc(var(--pic-densityLowInputHeight) + 2px);
            }
            .inner-input-default.medium{
                height: calc(var(--pic-densityMediumInputHeight) + 2px);
            }
            .inner-input-default.high{
                height: calc(var(--pic-densityHighInputHeight) + 2px);
            } */
            .inner-input.has-icon.force{
                cursor: pointer;
                /*height: 22px;*/
            }
            .disabled .icon{
                cursor: unset;
            }
            .disabled .mockinputfld.old{
                background-color: #f0f0f0;
                color: #545454;
                pointer-events: none;
            }
            .disabled .inner-input-default, .disabled .pic-body1{
                border-color: var(--pic-innerInputBorderDisabledColor);
                color: var(--pic-disabledColor);
                pointer-events: none;
            }
            .new-dual-style {
                border: none;
                background-color: var(--pic-backgroundColor, white);
                width: 100%;
                max-width: 85px;
            }
            input {
                caret-color: transparent;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    /*
        //styleName: PIC/Caption;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0.4000000059604645px;
        text-align: left;

        //styleName: PIC/Body 1;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.5px;
        text-align: left;
    */
    setValue(value) {
        let fromDate = value.split('^')[0];
        let toDate = value.split('^')[1];
        let format = parseFormat(this.format_);
        this.fromHelper = new Calendar({ dateString: fromDate, fullYear: format.fullYear, sep: format.sep, order: format.posArr });
        this.toHelper = new Calendar({ dateString: toDate, fullYear: format.fullYear, sep: format.sep, order: format.posArr });
    }
    getBlankValue() {
        let tmp = parseFormat(this.format_);
        return tmp.posArr.map(pos => this.fullYear && pos == Position.Year ? '––––' : '––').join(tmp.sep);
    }
    iconClick() {
        this.openPicker();
    }
    forceClose() {
        if (this.datePicker)
            this.datePicker.hide();
    }
    openPicker() {
        var _a, _b, _c, _d;
        this.datePicker.shouldHide = false;
        this.datePicker.data = {
            startDate: (_b = (_a = this.fromHelper) === null || _a === void 0 ? void 0 : _a.getDateObject()) !== null && _b !== void 0 ? _b : new Date(),
            endDate: (_d = (_c = this.toHelper) === null || _c === void 0 ? void 0 : _c.getDateObject()) !== null && _d !== void 0 ? _d : new Date(),
            infoText: this.info_,
            mode: 'dual',
            parent: this,
            markRanges: this.markRanges_
            /*markRanges: [
                {startDate: new Date(2022, 7, 1), endDate: new Date(2022, 7, 2), clickable: true, color: '#ff5005', message:'tooltip ud over det hele'},
                {startDate: new Date(2022, 7, 8), endDate: new Date(2022, 7, 10), clickable: true, color: '#ff5005', message:'tooltip ud over det hele'},
                {startDate: new Date(2022, 7, 15), endDate: new Date(2022, 7, 16), clickable: true, color: '#ff5005', message:'tooltip ud over det hele'},
                {startDate: new Date(2022, 7, 22), endDate: new Date(2022, 7, 26), clickable: true, color: '#ff5005', message:'tooltip ud over det hele'},
                {startDate: new Date(2022, 7, 29), endDate: new Date(2022, 7, 30), clickable: true, color: '#ff5005', message:'tooltip ud over det hele'},
                {startDate: new Date(2022, 7, 21), endDate: new Date(2022, 7, 19), clickable: true, color: '#ff5005', message:'tooltip ud over det hele'}
            ]*/
        };
        this.datePicker.toggle();
    }
    async handleSelect(e) {
        var _a, _b;
        if (e.detail.dates) {
            this.datePicker.toggle();
            (_a = this.fromHelper) === null || _a === void 0 ? void 0 : _a.setDate(e.detail.dates[0]);
            (_b = this.toHelper) === null || _b === void 0 ? void 0 : _b.setDate(e.detail.dates[1]);
            this.requestUpdate();
            await this.updateComplete;
            if (this.datePicker.show !== 'show' && this.submitValue !== this.initValue_) {
                this.changeHandler( /* NEEDS USEREVENT REF */);
            }
        }
        /*if(e.detail.date){
            if(e.detail.firstClick && !e.detail.clickEvent.ctrlKey && e.detail.date < this.fromHelper.getDateObject()){
                this.datePicker.toggle();
            } else if(!e.detail.firstClick){
                this.datePicker.toggle();
            }
            if(e.detail.firstClick){
                this.fromHelper.setDate(e.detail.date);
            } else {
                this.toHelper.setDate(e.detail.date);
            }
            this.requestUpdate();
            await this.updateComplete;
            if(this.datePicker.show !== 'show' && this.submitValue !== this.initValue_){
                this.changeHandler();
            }
        }*/
    }
    validateDateRange() {
        if (this.fromHelper && this.toHelper) {
            const fromDate = this.fromHelper.getDateObject();
            const toDate = this.toHelper.getDateObject();
            if (fromDate > toDate) {
                // Show error
                this.hasInvalidDate = true;
                this.validState = [{ pass: false, failMessage: 'From date cannot be after to date' }];
                this.requestUpdate();
                return false;
            }
            else {
                // Clear any previous errors
                this.hasInvalidDate = false;
                this.validState = [];
                return true;
            }
        }
        return true;
    }
    validate() {
        if (this.valid) {
            let testRes = this.valid.isInvalid(this.submitValue, false);
            if (typeof testRes == 'boolean') {
                this.validState = [];
            }
            else {
                this.validState = testRes;
            }
        }
    }
    async handleSelect2(e) {
        var _a, _b, _c, _d, _e, _f;
        if (e.detail.dates) {
            if (e.detail.dates.length == 2) {
                (_a = this.fromHelper) === null || _a === void 0 ? void 0 : _a.setDate(e.detail.dates[0]);
                (_b = this.toHelper) === null || _b === void 0 ? void 0 : _b.setDate(e.detail.dates[1]);
                // CRITICAL: Manually update input fields
                if (this.fromInputField) {
                    this.fromInputField.value = (_d = (_c = this.fromHelper) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : this.getBlankValue();
                }
                if (this.toInputField) {
                    this.toInputField.value = (_f = (_e = this.toHelper) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : this.getBlankValue();
                }
                this.requestUpdate();
                await this.updateComplete;
                if (this.submitValue !== this.initValue_) {
                    this.changeHandler( /* NEEDS USEREVENT REF */);
                }
            }
        }
    }
    async handlePickerClose(e) {
        await this.updateComplete;
        if (this.submitValue !== this.initValue_ && e.detail.type == 'close') {
            this.changeHandler( /* NEEDS USEREVENT REF */);
        }
    }
    leaveCheck(e) {
        var _a;
        this.editing = false;
        this.showFullError = false;
        let input = e === null || e === void 0 ? void 0 : e.target;
        let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
        let currentValue = input === null || input === void 0 ? void 0 : input.value;
        // Handle empty values - reset to blank state
        if (currentValue == this.getBlankValue()) {
            if (input === this.fromInputField) {
                this.fromHelper = new Calendar({ fullYear: this.fullYear, sep: this.sep, order: this.arrPos });
            }
            else {
                this.toHelper = new Calendar({ fullYear: this.fullYear, sep: this.sep, order: this.arrPos });
            }
            this.userHasInteracted = false;
        }
        if (!this.isSimple && currentValue) {
            let parsed = parseFormat(this.format_);
            let day = '';
            let month = '';
            let year = '';
            let separatedVals = currentValue.split(parsed.sep);
            if (separatedVals.length === 3) {
                day = separatedVals[parsed.posArr.indexOf(Position.Day)];
                month = separatedVals[parsed.posArr.indexOf(Position.Month)];
                year = separatedVals[parsed.posArr.indexOf(Position.Year)];
                // Validate the date components
                if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) {
                    this.hasInvalidDate = true;
                    return;
                }
                // Validate day length and format
                if (day.length > 2 || day.length == 0) {
                    this.hasInvalidDate = true;
                    return;
                }
                else if (day.length == 1) {
                    day = '0' + day;
                }
                // Validate month length and format
                if (month.length > 2 || month.length == 0) {
                    this.hasInvalidDate = true;
                    return;
                }
                else if (month.length == 1) {
                    month = '0' + month;
                }
                // Validate year length and format
                if (parsed.fullYear) { // we expect four digits
                    if (year.length > 4 || year.length < 2 || year.length == 3) {
                        this.hasInvalidDate = true;
                        return;
                    }
                }
                else { // we expect two digits
                    if (year.length !== 2) {
                        this.hasInvalidDate = true;
                        return;
                    }
                }
                if (year.length == 2) {
                    year = (2000 + parseInt(year)) + '';
                }
                // Set the validated date
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.setValue(Number(day), Number(month), Number(year));
                input.value = (_a = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _a !== void 0 ? _a : this.getBlankValue();
            }
        }
        // Validate date range after setting the date
        this.validateDateRange();
        this.requestUpdate();
    }
    inputNumber(iNum, input) {
        var _a, _b, _c, _d;
        let partialVal = '';
        let parts;
        let newPos;
        let replace = false;
        let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
        let currentValue = input.value;
        if (!this.userHasInteracted) {
            if (currentValue == this.getBlankValue())
                replace = true;
            this.handleUserInteraction();
        }
        if (!this.editing) {
            parts = currentValue.split(this.sep);
        }
        else {
            parts = this.editVal.split(this.sep);
        }
        let max;
        switch (this.getPos(input)) {
            case Position.Day: {
                max = 31;
                break;
            }
            case Position.Month: {
                max = 12;
                break;
            }
            case Position.Year: {
                if (this.fullYear)
                    max = 9999;
                else
                    max = 99;
                break;
            }
            default: {
                max = 9999;
                break;
            }
        }
        let partialIsNaN = false;
        partialVal = (_a = parts[this.arrPos.indexOf(this.getPos(input))]) !== null && _a !== void 0 ? _a : '';
        partialVal = (partialVal + '').replace(/[–]+/g, '');
        if (isNaN(parseInt(partialVal))) {
            partialVal = '0';
            partialIsNaN = true;
        }
        // Position checks
        const dayCheck = this.getPos(input) === Position.Day
            && parseInt(partialVal + iNum) <= max
            && (partialVal + iNum).length >= 2
            && !partialIsNaN
            && partialVal.length !== 2;
        const monthCheck = this.getPos(input) === Position.Month
            && parseInt(partialVal + iNum) <= max
            && (partialVal + iNum).length >= 2
            && !partialIsNaN
            && partialVal.length !== 2;
        const yearCheck = this.getPos(input) === Position.Year
            && parseInt(partialVal + iNum) <= max
            && (partialVal + iNum).length >= String(max).length
            && !partialIsNaN;
        const shouldGoNext = dayCheck || monthCheck || yearCheck;
        if (shouldGoNext) {
            partialVal = parseInt(partialVal) + '' + iNum;
            newPos = this.arrPos[this.arrPos.indexOf(this.getPos(input)) + 1];
        }
        else if (this.getPos(input) === Position.Year && (partialVal + iNum).length < String(max).length) {
            if (partialIsNaN)
                partialVal = '' + iNum;
            else
                partialVal = partialVal + iNum;
            newPos = this.getPos(input);
        }
        else {
            partialVal = iNum + '';
            newPos = this.getPos(input);
        }
        parts[this.arrPos.indexOf(this.getPos(input))] = partialVal;
        currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.setValue(Number((_b = parts[this.arrPos.indexOf(Position.Day)]) === null || _b === void 0 ? void 0 : _b.replace(/[–]+/g, '')), Number((_c = parts[this.arrPos.indexOf(Position.Month)]) === null || _c === void 0 ? void 0 : _c.replace(/[–]+/g, '')), Number((_d = parts[this.arrPos.indexOf(Position.Year)]) === null || _d === void 0 ? void 0 : _d.replace(/[–]+/g, '')));
        if (replace) {
            parts = this.getBlankValue().split(this.sep);
        }
        parts[this.arrPos.indexOf(this.getPos(input))] = this.getPos(input) == Position.Year && this.fullYear
            ? partialVal.padStart(4, '–')
            : partialVal.padStart(2, '–');
        this.editVal = parts.join(this.sep);
        input.value = this.editVal;
        this.setPos(input, newPos);
        this.validateDateRange();
    }
    // New method: Clear position
    clearPos(refresh, input) {
        if (!this.editing) {
            this.editing = true;
            this.editVal = input.value;
        }
        let tmp = this.editVal.split(this.sep);
        tmp[this.arrPos.indexOf(this.getPos(input))] = `${this.fullYear && this.getPos(input) == Position.Year ? '––––' : '––'}`;
        this.editVal = tmp.join(this.sep);
        if (refresh)
            input.value = this.editVal;
    }
    // New method: Reset field
    reset(input) {
        var _a;
        this.editing = false;
        let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
        currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.reset();
        input.value = (_a = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _a !== void 0 ? _a : this.getBlankValue();
        this.requestUpdate();
    }
    // New method: Increment value
    increment(shift, input) {
        var _a, _b;
        let pos;
        if (!shift)
            pos = this.getPos(input);
        else
            pos = Position.Month;
        let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
        // Store current state before making changes
        const currentValue = (_a = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _a !== void 0 ? _a : this.getBlankValue();
        switch (pos) {
            case Position.Day: {
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.addDay();
                break;
            }
            case Position.Month: {
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.addMonth();
                break;
            }
            case Position.Year: {
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.addYear();
                break;
            }
        }
        // Check if the change creates an invalid date range
        if (this.fromHelper && this.toHelper) {
            const fromDate = this.fromHelper.getDateObject();
            const toDate = this.toHelper.getDateObject();
            if (fromDate > toDate) {
                // Revert the change
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.setDate(new Date(currentValue));
                // Show error
                this.hasInvalidDate = true;
                this.validState = [{ pass: false, failMessage: 'From date cannot be after to date' }];
                this.requestUpdate();
                return;
            }
        }
        this.editing = false;
        input.value = (_b = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _b !== void 0 ? _b : this.getBlankValue();
        // Restore the selection to the same position
        this.setPos(input, pos);
        // Clear any previous errors
        this.hasInvalidDate = false;
        this.validState = [];
    }
    decrement(shift, input) {
        var _a, _b;
        let pos;
        if (!shift)
            pos = this.getPos(input);
        else
            pos = Position.Month;
        let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
        // Store current state before making changes
        const currentValue = (_a = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _a !== void 0 ? _a : this.getBlankValue();
        switch (pos) {
            case Position.Day: {
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.subtDay();
                break;
            }
            case Position.Month: {
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.subtMonth();
                break;
            }
            case Position.Year: {
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.subtYear();
                break;
            }
        }
        // Check if the change creates an invalid date range
        if (this.fromHelper && this.toHelper) {
            const fromDate = this.fromHelper.getDateObject();
            const toDate = this.toHelper.getDateObject();
            if (fromDate > toDate) {
                // Revert the change
                currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.setDate(new Date(currentValue));
                // Show error
                this.hasInvalidDate = true;
                this.validState = [{ pass: false, failMessage: 'From date cannot be after to date' }];
                this.requestUpdate();
                return;
            }
        }
        this.editing = false;
        input.value = (_b = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _b !== void 0 ? _b : this.getBlankValue();
        // Restore the selection to the same position
        this.setPos(input, pos);
        // Clear any previous errors
        this.hasInvalidDate = false;
        this.validState = [];
    }
    // New method: Add to clipboard
    addToClipBoard(input) {
        var _a;
        let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
        const el = document.createElement('textarea');
        el.value = (_a = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _a !== void 0 ? _a : '';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        input.select();
        this.setPos(input, this.getPos(input));
    }
    // New method: Handle user interaction
    handleUserInteraction() {
        if (!this.userHasInteracted) {
            this.userHasInteracted = true;
        }
    }
    // New method: Handle paste
    handlePaste(e, input) {
        var _a;
        this.hasInvalidDate = false;
        if (!this.isSimple) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (e.type == 'paste') {
                if (e.clipboardData) {
                    let paste = e.clipboardData.getData('text');
                    let sep = paste.replace(/[0-9]+/g, '').substr(0, 1);
                    let tmpDate;
                    let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
                    if (sep.length == 0) {
                        tmpDate = new Date('20' + paste.substr(0, 2) + '-' + paste.substr(2, 2) + '-' + paste.substr(4, 2));
                        if (isNaN(tmpDate.getTime())) {
                            tmpDate = new Date('20' + paste.substr(0, 2) + '-' + paste.substr(4, 2) + '-' + paste.substr(2, 2));
                        }
                    }
                    else {
                        tmpDate = new Date(paste.split(sep).join('-'));
                    }
                    if (isNaN(tmpDate.getTime())) {
                        return;
                    }
                    else {
                        currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.setDate(tmpDate);
                        input.value = (_a = currentHelper === null || currentHelper === void 0 ? void 0 : currentHelper.toString()) !== null && _a !== void 0 ? _a : '';
                    }
                }
            }
        }
    }
    setDisplayformat(iPos, iFullYear) {
        let posCounter = 0;
        this.fromPositions = new Map();
        this.toPositions = new Map();
        this.arrPos = iPos;
        // From input
        for (let i = 0; 3 > i; i++) {
            //@ts-ignore
            this.fromPositions.set(iPos[i], [posCounter, (posCounter += 2)]);
            if (iFullYear && iPos[i] == Position.Year) {
                //@ts-ignore
                this.fromPositions.get(iPos[i])[1] = posCounter += 2;
            }
            posCounter++;
        }
        posCounter = 0;
        // To input
        for (let i = 0; 3 > i; i++) {
            //@ts-ignore
            this.toPositions.set(iPos[i], [posCounter, (posCounter += 2)]);
            if (iFullYear && iPos[i] == Position.Year) {
                //@ts-ignore
                this.toPositions.get(iPos[i])[1] = posCounter += 2;
            }
            posCounter++;
        }
    }
    moveCaret(input, direction) {
        let parsed = parseFormat(this.format_);
        let arrPos = parsed.posArr;
        if (!arrPos) {
            console.log('format not found');
            return;
        }
        let pos = this.getPos(input);
        let currentIndex = arrPos.indexOf(pos);
        let newIndex = null;
        if (direction === 'ArrowRight') {
            newIndex = Math.min(currentIndex + 1, arrPos.length - 1);
        }
        else if (direction === 'ArrowLeft') {
            newIndex = Math.max(currentIndex - 1, 0);
        }
        else {
            newIndex = currentIndex;
        }
        let newPos = arrPos[newIndex];
        this.setPos(input, newPos);
    }
    getPos(input) {
        var _a;
        let caretPos = (_a = input === null || input === void 0 ? void 0 : input.selectionStart) !== null && _a !== void 0 ? _a : 0;
        let positionMap = input === this.toInputField ? this.toPositions : this.fromPositions;
        for (let [key, [start, end]] of positionMap) {
            if (caretPos >= start && caretPos <= end) {
                return key;
            }
        }
        return Position.All;
    }
    setPos(input, position) {
        let positionMap = input === this.toInputField ? this.toPositions : this.fromPositions;
        if (position === Position.All) {
            input.select();
        }
        else {
            let pos = positionMap.get(position);
            if (pos) {
                input.focus();
                setTimeout(() => {
                    input.setSelectionRange(pos[0], pos[1]);
                }, 0);
            }
        }
    }
    handleKeys(e) {
        let input = e.target;
        if (!this.isSimple) {
            if (![
                'Escape', 'Tab', 'Alt', 'F1',
                'F2', 'F3', 'F4', 'F5', 'F6',
                'F7', 'F8', 'F9', 'F10', 'F11', 'F12'
            ].includes(e.key) && !(e.ctrlKey && e.key == 'v')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.hasInvalidDate = false;
            }
            let currentHelper = input === this.fromInputField ? this.fromHelper : this.toHelper;
            if (!this.userHasInteracted && (this.fromHelper === null || this.toHelper === null)) {
                if (['ArrowUp', 'ArrowDown', '.'].includes(e.key)) {
                    this.handleUserInteraction();
                }
            }
            if (['ArrowLeft', 'ArrowRight'].includes(e.key)) {
                this.moveCaret(input, e.key);
            }
            else if (['ArrowUp'].includes(e.key)) {
                this.increment(e.shiftKey, input);
            }
            else if (['ArrowDown'].includes(e.key)) {
                this.decrement(e.shiftKey, input);
            }
            else if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key)) {
                if (currentHelper === null) {
                    let tmp = parseFormat(this.format_);
                    if (input === this.fromInputField) {
                        this.fromHelper = new Calendar({ fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
                    }
                    else {
                        this.toHelper = new Calendar({ fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
                    }
                }
                // this.editing = true;  
                this.inputNumber(parseInt(e.key), input);
            }
            else if (['.'].includes(e.key)) {
                this.reset(input);
            }
            else if (e.ctrlKey && e.key == 'c') {
                this.addToClipBoard(input);
            }
            else if (['Enter'].includes(e.key)) {
                this.leaveCheck();
                if (!this.changeEvent)
                    this.enterSubmit(e);
            }
            else if (e.ctrlKey && e.key == 'a') {
                input.select();
            }
            else if (['Delete', 'Backspace'].includes(e.key)) {
                if (input.selectionStart === 0 && input.selectionEnd === input.value.length) {
                    if (input === this.fromInputField) {
                        this.fromHelper = new Calendar({ fullYear: true, sep: '', order: [Position.Year, Position.Month, Position.Day] });
                    }
                    else {
                        this.toHelper = new Calendar({ fullYear: true, sep: '', order: [Position.Year, Position.Month, Position.Day] });
                    }
                    input.value = this.getBlankValue();
                    this.editVal = this.getBlankValue();
                }
                else {
                    this.clearPos(true, input);
                }
            }
            else {
                return false;
            }
        }
    }
    focusHandler(mode, e) {
        if (mode === 'in') {
            this.showFullError = true;
            if ((e === null || e === void 0 ? void 0 : e.target) instanceof HTMLInputElement) {
                e.target.select();
            }
        }
        if (mode === 'out') {
            this.showFullError = false;
            let parsed = parseFormat(this.format_);
            let day = '';
            let month = '';
            let year = '';
            let separatedVals = [];
            if ((e === null || e === void 0 ? void 0 : e.target) === this.fromInputField) {
                separatedVals = this.fromInputField.value.split(parsed.sep);
            }
            if ((e === null || e === void 0 ? void 0 : e.target) === this.toInputField) {
                separatedVals = this.toInputField.value.split(parsed.sep);
            }
            if (separatedVals.length === 3) {
                day = separatedVals[parsed.posArr.indexOf(Position.Day)];
                month = separatedVals[parsed.posArr.indexOf(Position.Month)];
                year = separatedVals[parsed.posArr.indexOf(Position.Year)];
                if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) {
                    this.hasInvalidDate = true;
                }
                if (day.length > 2 || day.length == 0) {
                    this.hasInvalidDate = true;
                }
                else if (day.length == 1) {
                    day = '0' + day;
                }
                if (month.length > 2 || month.length == 0) {
                    this.hasInvalidDate = true;
                }
                else if (month.length == 1) {
                    month = '0' + month;
                }
                if (parsed.fullYear) { // we expect four digits
                    if (year.length > 4 || year.length < 2 || year.length == 3) {
                        this.hasInvalidDate = true;
                    }
                }
                else { // we expect two digits
                    if (year.length !== 2) {
                        this.hasInvalidDate = true;
                    }
                }
                if (year.length == 2) {
                    year = 2000 + parseInt(year) + '';
                }
            }
            if (this.hasInvalidDate) {
                console.log('invalid date');
            }
            else {
                if ((e === null || e === void 0 ? void 0 : e.target) === this.fromInputField) {
                    this.fromHelper.setValue(Number(day), Number(month), Number(year));
                    this.fromInputField.value = this.fromHelper.toString();
                }
                if ((e === null || e === void 0 ? void 0 : e.target) === this.toInputField) {
                    this.toHelper.setValue(Number(day), Number(month), Number(year));
                    this.toInputField.value = this.toHelper.toString();
                }
            }
            this.validateDateRange();
        }
        this.requestUpdate();
    }
    getInputClass(type) {
        return {
            'from-inner-input': type === 'from',
            'to-inner-input': type === 'to',
            'pic-body1': this.eType != 'old' && this.density == 'low' || this.density == 'medium',
            'pic-body2': this.eType != 'old' && this.density == 'high' || this.density == 'inline',
        };
    }
    firstUpdated() {
        this.initValue_ = this.submitValue;
    }
    renderPicker() {
        if (this.eType == 'old' && this.density == 'old') {
            return html `
                <div class="picker">
                    <pic-datepicker @valueselected=${this.handleSelect} id="datepicker"></pic-datepicker>
                </div>
            `;
        }
        else {
            return html `
                <div class="picker new ${this.density}">
                    <pic-datepicker2 ?hasweekno=${this.hasWeekNo_} ?removeclearbtn=${this.removeClearBtn_} dateselectionmode="range" @valueselected=${this.handleSelect2} id="datepicker"></pic-datepicker2>
                </div>
            `;
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.eType == 'old') {
            this.setComponentInlineStyle('230px');
            return html `
                ${this.renderCSS(true)}
                <div 
                    style=${styleMap(this.getContainerStyle())} 
                    tabindex="0"
                    class="container ${this.disabled_ ? 'disabled' : ''}"
                    >
                    <label for=${this.id_ + '_inner'}>${this.label}</label>
                    <div class="mockinputfld old" @click=${this.openPicker}>
                    ${(_b = (_a = this.fromHelper) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : this.getBlankValue()} - ${(_d = (_c = this.toHelper) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : this.getBlankValue()}
                    </div>
                    ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
                    ${this.renderPicker()} 
                </div>
                ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
                `;
        }
        else {
            this.setComponentInlineStyle('300px');
            return html `
                ${this.renderCSS(true)}
                <div 
                    style=${styleMap(this.getContainerStyle())} 
                    class=${classMap(this.classAdder(this.getContainerClassMap(), this.disabled_ ? 'disabled' : ''))}
                    >
                    <label class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} for=${this.id_ + '_inner'}>${this.label}</label>
                    <div 
                        class=${classMap(this.classAdder(this.getInnerInputClass(), 'force'))}
                        >
                        ${this.textObj.fromText}&nbsp;
                        <input
                                tabindex="0"
                                id=${this.id_ + '_inner'}
                                inputmode="numeric"
                                type="text"
                                class="${classMap(this.getInputClass('from'))} new-dual-style"
                                ?disabled=${this.disabled_}
                                placeholder=${this.placeholder}
                                value=${(_f = (_e = this.fromHelper) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : this.getBlankValue()}
                                @keydown=${this.handleKeys}
                                @paste=${(e) => this.handlePaste(e, this.fromInputField)}
                                @focusin=${(e) => this.focusHandler('in', e)}
                                @focusout=${(e) => this.focusHandler('out', e)}
                        />
                        &nbsp;${this.textObj.toText}&nbsp;
                        <input
                                tabindex="0"
                                id=${this.id_ + '_inner'}
                                inputmode="numeric"
                                type="text"
                                class="${classMap(this.getInputClass('to'))} new-dual-style"
                                ?disabled=${this.disabled_}
                                placeholder=${this.placeholder}
                                value=${(_h = (_g = this.toHelper) === null || _g === void 0 ? void 0 : _g.toString()) !== null && _h !== void 0 ? _h : this.getBlankValue()}
                                @keydown=${this.handleKeys}
                                @paste=${(e) => this.handlePaste(e, this.toInputField)}
                                @focusin=${(e) => this.focusHandler('in', e)}
                                @focusout=${(e) => this.focusHandler('out', e)}
                        />
                    </div>
                    ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
                    ${this.renderPicker()} 
                    ${this.renderErr(this.showFullError)}
                </div>
                ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
            `;
        }
    }
};
__decorate([
    query('.from-inner-input')
], PICDualDate.prototype, "fromInputField", void 0);
__decorate([
    query('.to-inner-input')
], PICDualDate.prototype, "toInputField", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'fromdate' })
], PICDualDate.prototype, "fromDate_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'todate' })
], PICDualDate.prototype, "toDate_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'format' })
], PICDualDate.prototype, "format_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'info' })
], PICDualDate.prototype, "info_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'hasweekno' })
], PICDualDate.prototype, "hasWeekNo_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'autoclose' })
], PICDualDate.prototype, "autoclose_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'removeclearbtn' })
], PICDualDate.prototype, "removeClearBtn_", void 0);
__decorate([
    property({ converter: arrayDecoder, attribute: 'markranges' })
], PICDualDate.prototype, "markRanges_", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'range' })
], PICDualDate.prototype, "maxRange", void 0);
__decorate([
    query('#datepicker')
], PICDualDate.prototype, "datePicker", void 0);
PICDualDate = __decorate([
    customElement('pic-dualdate')
], PICDualDate);
export { PICDualDate };
function toReturnValue(iDate) {
    if (iDate) {
        return (iDate.getFullYear() + '').padStart(4, '0') + '-' + ((iDate.getMonth() + 1) + '').padStart(2, '0') + '-' + (iDate.getDate() + '').padStart(2, '0');
    }
    else {
        return '';
    }
}
/*function to*/ 
//# sourceMappingURL=PICDualDate.js.map